import React from 'react'
import { Modal } from 'react-bootstrap';
interface LoadingProps {
  show: boolean,
  onClose?: Function,
}

const Loading: React.FC<LoadingProps> = ({ show, onClose}) => {
  return(
    <Modal size="sm" show={show} onHide={() => { if(onClose != undefined) onClose() }} animation={false}>
      <Modal.Body style={{marginLeft:15}}>
        <img src="img/loading.gif" alt="Loading"  width={250}/>
      </Modal.Body>
    </Modal>
  )

}

export default Loading;

